import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { whatsAppLink } from "../config/commonConfig";

const FAQs = () => {
  const faqsData = [
    {
      question: "1) Oportunidade de Crescimento do seu negócio com a alta demanda de cursos especializados para motoristas profissionais",
      answer:
        "Aproveite a crescente busca por especializações no setor de trânsito, especialmente nos cursos de Reciclagem de Condutores e capacitação profissional de motorista, que seguem em expansão em todo o Brasil.",
    },
    {
      question: "2) Possibilidade de comercialização dos cursos em todo Brasil",
      answer:
        "Com a EAD Rio Branco você pode ofertar e vender os cursos para alunos localizados em qualquer região do país. Isso significa que, independentemente do estado ou cidade, o conteúdo pode ser acessado remotamente, permitindo maior alcance de público, expansão da base de clientes e aumento do potencial de receita.",
    },
    {
      question: "3) Confiança e Qualidade de quem tem experiência",
      answer:
        "Já formamos mais de 120 mil condutores especializados. A EAD Rio Branco nasceu da experiência prática de um grupo de empresários com trajetória consolidada no setor de formação de condutores. Com raízes em autoescola, carregamos conosco a responsabilidade, o compromisso com a educação no trânsito e o olhar atento às reais necessidades dos profissionais da área.",
    },
    {
      question: "4) Material editável para divulgação",
      answer:
        "Fornecemos materiais de divulgação prontos para uso, como banners, artes e imagens promocionais, desenvolvidos com padrão profissional. Assim, nossos parceiros contam com ferramentas de comunicação eficientes e alinhadas à identidade da EAD Rio Branco, facilitando a promoção dos cursos com qualidade e agilidade.",
    },
    {
      question: "5) Suporte Técnico e Comercial Especializado",
      answer:
        "Contamos com uma equipe dedicada para oferecer suporte completo — técnico e comercial — aos nossos revendedores e diretos aos seus alunos. Este atendimento personalizado garante agilidade na resolução de dúvidas, apoio em questões operacionais e orientações estratégicas, permitindo que você concentre seus esforços no crescimento e nas vendas com total segurança.",
    },
    {
      question: "6) Plataforma com Área Exclusiva para o Revendedor",
      answer:
        "A EAD Rio Branco oferece uma plataforma intuitiva e moderna com área exclusiva para cada parceiro. Nesse ambiente personalizado, o revendedor pode acompanhar matrículas, gerenciar alunos e ter controle total sobre suas vendas — tudo de forma prática, segura e centralizada.",
    },
    {
      question: "7) Processo de matrícula de aluno simplificado",
      answer:
        "Com um sistema de matrícula simples, fácil e rápido, integrado com os Detrans. Com um processo pensado para facilitar a experiência do aluno do início ao fim. Todo o processo de inscrição é rápido, direto e conta com o suporte da nossa equipe de atendimento.",
    },
    {
      question: "8) Curso de qualidade com aulas 100% vídeo, suporte ao direto ao aluno pelo WhatsApp",
      answer:
        "Nossos cursos são apresentados em formato totalmente audiovisual, com conteúdo dinâmicos e de fácil assimilação. Além disso, cada aluno conta com o acompanhamento de um tutor diretamente na plataforma, pronto para esclarecer dúvidas e oferecer o suporte necessário durante todo o processo. O resultado é uma experiência de aprendizado completa, que se reflete em altos índices de aprovação nas provas do Detran.",
    }
  ];

  return (
    <section id="faq" className="section">
      <div className="container">
        <h2 className="text-9 fw-600 text-center">
          VANTAGENS DE SER UM REVENDEDOR DA EAD RIO BRANCO
        </h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Leia atentamente e ficando com dúvidas entre em contato conosco.
        </p>
        <div className="row">
          <div className="col-md-10 col-lg-8 mx-auto">
            <hr className="mb-0 opacity-1" />
            <Accordion flush defaultActiveKey="0" className="arrow-end">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
            <hr className="mt-0 opacity-1" />
          </div>
        </div>
        <div className="lead text-center mt-4">
          Não fique com dúvidas, {" "}
          <a
            href={whatsAppLink}
            target="_blank"
            rel="noopener noreferrer"
            className="smooth-scroll link-offset-2 link-underline link-underline-opacity-0-hover"
          >
            envie agora sua mensagem pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
